import { useQueryParams } from "Utils/router";
import { getCorrectPlatform } from "Utils/utils";

export const useCheckIsCif = (modules, platformShortName, originalSource) => {
  const cifModule = modules?.filter(
    (m) => m.moduleid === "registration_cif"
  )[0];
  const correctPlatform = getCorrectPlatform(platformShortName, originalSource);
  const isCif = cifModule?.[correctPlatform] === "1";

  const { cif: cifQueryParam } = useQueryParams();
  return isCif && cifQueryParam !== "0";
};
